import { Pipe, PipeTransform } from '@angular/core';
import { FiscalIdKind } from '../models/common/fiscal-id.model';
import { Lead } from '../models/lead/lead.model';

@Pipe({
    name: 'isLeadAssignable',
    standalone: false
})
export class IsLeadAssignablePipe implements PipeTransform {

  transform(value: Lead): boolean {
    return (value.province ?? value.municipality ?? false) &&
      value.fiscalIds.filter(f => f.kind == FiscalIdKind.PartitaIva).length > 0 &&
      value.contacts.length > 0
  }

}
